import i18n from '@/i18n';
const Layout = () => import('@/layouts/main.vue');
const FeedbackQuestion = () => import('./views/Index.vue');

export default [
  {
    path: '/feedback-question',
    component: Layout,
    meta: { authRequired: true, header: true, permission: 'superadmin|marketing' },
    children: [
      {
        path: '',
        name: 'FeedbackQuestion',
        component: FeedbackQuestion,
        meta: { title: i18n.global.t('settings.feedbackQuestion') },
      },
    ],
  },
];
